const getPropsFromWindow = function getPropsFromWindowObject(Component, domId) {
  return window.upCouponAdmin[domId];
};

export default getPropsFromWindow;
